import { render, staticRenderFns } from "./redeem-inside.vue?vue&type=template&id=06febe72&scoped=true&"
import script from "./redeem-inside.vue?vue&type=script&lang=js&"
export * from "./redeem-inside.vue?vue&type=script&lang=js&"
import style0 from "./redeem-inside.vue?vue&type=style&index=0&id=06febe72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06febe72",
  null
  
)

export default component.exports